<template>
  <div id="releaseNotes">
    <PageTitle :title="$t('release_notes.title')" :subtitle="$t('release_notes.subtitle')"></PageTitle>

    <PageContainer>
      <Empty v-if="notes.length === 0" :text="$t('release_notes.empty')"></Empty>

      <div class="release" v-for="release of notes">

        <div class="column release__header">
          <div class="release__version column__left">{{ release.version }}</div>
          <div class="release__date column__right">
            <div class="date--main">{{ getReleaseDateAsFormattedString(release) }}</div>
            <div class="date--since">{{ $t('release_notes.days_ago').replace("{DAYS}", getRangeFromReleaseToNow(release)) }}</div>
          </div>
        </div>

        <div class="column release__description" v-if="release.description && $to(release.description.new)">
          <div class="release__title column__left">{{ $t('release_notes.new') }}</div>
          <div class="release__content column__right">{{ $to(release.description.new) }}</div>
        </div>

        <div class="column release__description" v-if="release.description && $to(release.description.improved)">
          <div class="release__title column__left">{{ $t('release_notes.improved') }}</div>
          <div class="release__content column__right">{{ $to(release.description.improved) }}</div>
        </div>

        <div class="column release__description" v-if="release.description && $to(release.description['fixed'])">
          <div class="release__title column__left">{{ $t('release_notes.fixed') }}</div>
          <div class="release__content column__right">{{ $to(release.description['fixed']) }}</div>
        </div>

      </div>
    </PageContainer>

  </div>
</template>

<script>
  import {Core} from "@/core/Core";
  import { DateTime } from "luxon";
  import { LocalizeStore } from "@/resources/localize";
  import PageTitle from "@/components/PageTitle";
  import PageContainer from "@/components/PageContainer";
  import Empty from "@/components/tools/Empty";

  export default {
    name: "releaseNotes",

    components: { PageTitle, PageContainer, Empty },

    data() {
      return {
        notes: [],
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "release_notes.title";
      this.$store.state.pageIcon = "/icon/version-history.svg";
      showSpinner();
      let notesHistory = await this.getReleaseNotesHistory();
      if (notesHistory && notesHistory.platform) {
        this.notes = notesHistory.platform['web'];
      } else {
        this.notes = [];
      }
      hideSpinner();
    },

    methods: {
      async getReleaseNotesHistory() {
        let response = await Core.noThrowRequest('GET', '/api/app_versions/admin/history');
        if (response) {
          return response;
        }
      },

      getReleaseDateAsFormattedString(release) {
        if (release.releaseDate) {
          try {
            let date = DateTime.fromFormat(release.releaseDate, 'yyyy-MM-dd');
            return date.setLocale(LocalizeStore.state.locale).toLocaleString(DateTime.DATE_HUGE);
          } catch(e) {
            console.log(e);
            return '';
          }
        }
        return '';
      },

      getRangeFromReleaseToNow(release) {
        if (release.releaseDate) {
          try {
            let date = DateTime.fromFormat(release.releaseDate, 'yyyy-MM-dd');
            let diff = DateTime.now().diff(date, ["days"]).days;
            return Math.floor(diff).toString();
          } catch(e) {
            console.log(e);
            return '';
          }
        }
        return '';
      }
    }
  }
</script>

<style lang="scss" scoped >
  #releaseNotes {
    overflow: auto;
    display: flex;
    flex-direction: column;

    .release:not(:last-of-type) {
      border-bottom: 2px dashed #E6E6E6;
    }
    .column {
      display: flex;
      padding: 0 0 20px 0;
      &.release__header {
        padding-top: 20px;
      }
    }
    .column__left {
      display: flex;
      width: 115px;
      margin-right: 30px;
      color: var(--primary-color);
      font-weight: bold;
      justify-content: flex-end;
      align-items: flex-start;
      flex-shrink: 0;
      font-size: 18px;
      &.release__version {
        justify-content: center;
        align-items: center;
      }
    }
    .column__right {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      font-size: 19px;
      color: black;
      .date--main {
        font-size: 22px;
        font-weight: bold;
        text-transform: capitalize;
      }
      .date--since {
        color: #808080;
        font-size: 16px;
      }
    }

    .release__version {
      background: transparent linear-gradient(114deg, #ED2937 0%, #FC6650 100%) 0 0 no-repeat padding-box;
      border-radius: 12px;
      color: white;
      height: 56px;
      font-size: 18px;
    }

    .release__content {
      white-space: pre-wrap;
    }
  }
</style>